import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import {
  Modal,
  Button,
  Container,
  Row,
  Col
} from 'react-bootstrap';

import RequestServies from '../../../services/RequestServies';
import LocationServices from '../../../services/LocationServices';
import Select from "react-select";

const TransferForm = ({
  show,
  handleClose,
  store,
  onSuccess
}) => {

  const initialFormValues = {
    transferNo: 0,
    storeFrom: '',
    storeTo: '',
    image: null
  };

  const [
    formValues,
    setFormValues
  ] = useState(
    initialFormValues
  );

  const [
    previewImage,
    setPreviewImage
  ] = useState(
    'img/placeholder-img.png'
  );

  const [
    storeData,
    setStoreData
  ] = useState([]);

  // ✅ SAME AS MRV
  const [
    uploadProgress,
    setUploadProgress
  ] = useState(0);

  // ✅ SAME AS MRV
  const [
    isCompressing,
    setIsCompressing
  ] = useState(false);


  // ============================================================
  // INPUT CHANGE
  // ============================================================

  const handleInputChange =
    (event) => {

      const {
        name,
        value
      } = event.target;

      setFormValues(
        (prev) => ({
          ...prev,
          [name]: value
        })
      );
    };


  // ============================================================
  // IMAGE CHANGE + COMPRESSION
  // SAME LOGIC AS MRV
  // ============================================================

  const handleFileChange =
    async (event) => {

      const files =
        event.target.files;

      if (
        !files ||
        files.length === 0
      ) {
        return;
      }

      const file =
        files[0];


      // ==========================================
      // SHOW PREVIEW IMMEDIATELY
      // ==========================================

      const previewURL =
        URL.createObjectURL(
          file
        );

      setPreviewImage(
        previewURL
      );

      setIsCompressing(
        true
      );


      try {

        const img =
          new Image();

        img.src =
          previewURL;


        img.onload = () => {

          const canvas =
            document.createElement(
              'canvas'
            );

          const MAX_WIDTH =
            800;


          // ========================================
          // DO NOT UPSCALE SMALL IMAGE
          // ========================================

          const scaleSize =
            Math.min(
              1,
              MAX_WIDTH /
                img.width
            );


          canvas.width =
            Math.round(
              img.width *
                scaleSize
            );

          canvas.height =
            Math.round(
              img.height *
                scaleSize
            );


          const ctx =
            canvas.getContext(
              '2d'
            );


          ctx.drawImage(
            img,
            0,
            0,
            canvas.width,
            canvas.height
          );


          // ========================================
          // COMPRESS AS JPEG
          // ========================================

          canvas.toBlob(
            (blob) => {

              setIsCompressing(
                false
              );


              // ====================================
              // FALLBACK TO ORIGINAL FILE
              // ====================================

              if (!blob) {

                setFormValues(
                  (prev) => ({
                    ...prev,
                    image: file
                  })
                );

                return;
              }


              const compressedFile =
                new File(
                  [blob],
                  file.name,
                  {
                    type:
                      'image/jpeg',

                    lastModified:
                      Date.now()
                  }
                );


              console.log(
                "TRANSFER ORIGINAL IMAGE:",
                (
                  file.size /
                  1024 /
                  1024
                ).toFixed(2),
                "MB"
              );


              console.log(
                "TRANSFER COMPRESSED IMAGE:",
                (
                  compressedFile.size /
                  1024 /
                  1024
                ).toFixed(2),
                "MB"
              );


              setFormValues(
                (prev) => ({
                  ...prev,
                  image:
                    compressedFile
                })
              );

            },

            'image/jpeg',

            // Same quality as MRV
            0.7
          );
        };


        // ==========================================
        // IMAGE LOAD FAILED
        // USE ORIGINAL FILE
        // ==========================================

        img.onerror = () => {

          setIsCompressing(
            false
          );

          setFormValues(
            (prev) => ({
              ...prev,
              image: file
            })
          );
        };


      } catch (error) {

        console.error(
          "Transfer image compression error:",
          error
        );

        setIsCompressing(
          false
        );

        setFormValues(
          (prev) => ({
            ...prev,
            image: file
          })
        );
      }
    };


  // ============================================================
  // STORE DATA
  // ============================================================

  useEffect(() => {

    LocationServices
      .getStore()

      .then((res) => {

        const filteredStores =
          res?.data?.data?.filter(
            (storeItem) =>
              storeItem._id !==
              formValues.storeFrom
          ) || [];

        setStoreData(
          filteredStores
        );
      })

      .catch((error) => {

        console.error(
          'Error fetching stores:',
          error
        );
      });

  }, [
    formValues.storeFrom
  ]);


  // ============================================================
  // SUBMIT
  // ============================================================

  const handleSubmit =
    async (event) => {

      event.preventDefault();


      // ==========================================
      // PREVENT SUBMIT DURING COMPRESSION
      // ==========================================

      if (isCompressing) {

        Swal.fire({
          icon: 'info',
          title: 'Please Wait',
          text:
            'Image is still being processed.'
        });

        return;
      }


      // ==========================================
      // EXISTING VALIDATION
      // ==========================================

      if (!formValues.transferNo) {

        Swal.fire({
          icon: 'warning',
          title:
            'Validation Error',
          text:
            'Please enter a Transfer Number'
        });

        return;
      }


      if (!formValues.storeFrom) {

        Swal.fire({
          icon: 'warning',
          title:
            'Validation Error',
          text:
            'Please select a store to transfer from'
        });

        return;
      }


      if (!formValues.storeTo) {

        Swal.fire({
          icon: 'warning',
          title:
            'Validation Error',
          text:
            'Please select a store to transfer to'
        });

        return;
      }


      if (!formValues.image) {

        Swal.fire({
          icon: 'warning',
          title:
            'Validation Error',
          text:
            'Please upload an image'
        });

        return;
      }


      try {

        setUploadProgress(
          0
        );


        const formData =
          new FormData();


        // ==========================================
        // SAME EXISTING PAYLOAD STRUCTURE
        // ==========================================

        for (
          const key in formValues
        ) {

          if (
            formValues[key]
          ) {

            formData.append(
              key,
              formValues[key]
            );
          }
        }


        // ==========================================
        // CREATE TRANSFER
        // ==========================================

        await RequestServies
          .createTransfer(
            formData,
            (progressEvent) => {

              if (
                !progressEvent
                  ?.total
              ) {
                return;
              }

              const percent =
                Math.round(
                  (
                    progressEvent
                      .loaded *
                    100
                  ) /
                  progressEvent
                    .total
                );


              setUploadProgress(
                percent
              );
            }
          );


        Swal.fire({
          icon: 'success',
          title: 'Success',
          text:
            'Transfer Form Added Successfully'
        });


        setUploadProgress(
          0
        );


        onSuccess();

        handleClose();


      } catch (error) {

        setUploadProgress(
          0
        );


        Swal.fire({
          icon: 'error',
          title:
            'Submission Error',

          text:
            error
              ?.response
              ?.data
              ?.message ||
            'An error occurred while adding the transfer form'
        });
      }
    };


  // ============================================================
  // RESET
  // ============================================================

  useEffect(() => {

    if (!show) {

      setFormValues(
        initialFormValues
      );

      setPreviewImage(
        'img/placeholder-img.png'
      );

      setUploadProgress(
        0
      );

      setIsCompressing(
        false
      );
    }

  }, [
    show
  ]);


  // ============================================================
  // RENDER
  // ============================================================

  return (

    <Modal
      className="fade"
      show={show}
      onHide={handleClose}
    >

      <form
        onSubmit={
          handleSubmit
        }
      >

        <Modal.Header>

          <Modal.Title>
            Transfer Form
          </Modal.Title>

        </Modal.Header>


        <Modal.Body>

          <Container>

            <Row>

              <Col md="6">

                <label>
                  Transfer No
                </label>

                <input
                  type="number"
                  name="transferNo"
                  value={
                    formValues
                      .transferNo
                  }
                  onChange={
                    handleInputChange
                  }
                  className="form-control form-control-sm"
                />

              </Col>


              <Col md="6">

                <label>
                  From
                </label>

                <Select
                  options={
                    store?.map(
                      (s) => ({
                        value:
                          s._id,
                        label:
                          s.name
                      })
                    )
                  }

                  value={
                    store
                      ?.map(
                        (s) => ({
                          value:
                            s._id,
                          label:
                            s.name
                        })
                      )
                      .find(
                        (opt) =>
                          opt.value ===
                          formValues
                            .storeFrom
                      ) ||
                    null
                  }

                  onChange={(
                    selected
                  ) =>
                    setFormValues(
                      (prev) => ({
                        ...prev,

                        storeFrom:
                          selected
                            ? selected.value
                            : ""
                      })
                    )
                  }

                  placeholder="Select a Store"

                  isSearchable
                />

              </Col>

            </Row>


            <Row className="mt-3">

              <Col md="6">

                <label>
                  To
                </label>

                <Select
                  options={
                    storeData?.map(
                      (s) => ({
                        value:
                          s._id,

                        label:
                          s.name
                      })
                    )
                  }

                  value={
                    storeData
                      ?.map(
                        (s) => ({
                          value:
                            s._id,

                          label:
                            s.name
                        })
                      )
                      .find(
                        (opt) =>
                          opt.value ===
                          formValues
                            .storeTo
                      ) ||
                    null
                  }

                  onChange={(
                    selected
                  ) =>
                    setFormValues(
                      (prev) => ({
                        ...prev,

                        storeTo:
                          selected
                            ? selected.value
                            : ""
                      })
                    )
                  }

                  placeholder="Select a Store"

                  isSearchable
                />

              </Col>


              <Col md="6">

                <label>
                  Upload Image
                </label>


                <input
                  type="file"
                  name="image"
                  accept="image/*"
                  capture="environment"
                  className="form-control form-control-sm"

                  onClick={(e) => {
                    e.target.value =
                      null;
                  }}

                  onChange={
                    handleFileChange
                  }
                />


                {/* COMPRESSION LOADER */}

                {isCompressing && (

                  <div className="text-center mt-2">

                    <div
                      className="spinner-border text-primary"
                      role="status"
                    />

                    <div className="mt-1">
                      Compressing image...
                    </div>

                  </div>

                )}


                {/* IMAGE PREVIEW */}

                {
                  previewImage &&
                  previewImage !==
                    'img/placeholder-img.png' &&
                  !isCompressing && (

                    <div className="file-preview text-center mt-2">

                      <img
                        id="uploadFile"
                        src={
                          previewImage
                        }
                        alt="Preview"
                        className="img-fluid"

                        style={{
                          maxHeight:
                            "200px",

                          objectFit:
                            "contain"
                        }}
                      />

                    </div>

                  )
                }


                {/* UPLOAD PROGRESS */}

                {
                  uploadProgress >
                    0 &&
                  uploadProgress <
                    100 && (

                    <div className="progress mt-2">

                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"

                        style={{
                          width:
                            `${uploadProgress}%`
                        }}
                      >

                        Uploading...{" "}
                        {
                          uploadProgress
                        }%

                      </div>

                    </div>

                  )
                }

              </Col>

            </Row>

          </Container>

        </Modal.Body>


        <Modal.Footer>

          <Button
            variant="danger light"
            onClick={
              handleClose
            }

            disabled={
              isCompressing ||
              (
                uploadProgress >
                0
              )
            }
          >
            Close
          </Button>


          <Button
            variant="primary"
            type="submit"

            disabled={
              isCompressing ||
              uploadProgress > 0
            }
          >

            {
              isCompressing
                ? "Processing..."
                : uploadProgress >
                    0
                  ? "Uploading..."
                  : "Save changes"
            }

          </Button>

        </Modal.Footer>

      </form>

    </Modal>
  );
};


export default TransferForm;